import { useCallback, ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { dayChange } from "../../actions";
import { getTodayDate } from "../../utils/date";
import { getCurrentDay } from "../../state/currentDay.selectors";
import { h } from "../../h";

const GoToTodayContainerStyled = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const GoToToday = (): ReactElement | null => {
    const dispatch = useDispatch();
    const today = getTodayDate();
    const currentDay = useSelector(getCurrentDay);
    const onClick = useCallback(() => {
        dispatch(dayChange(today));
    }, [dispatch, today]);
    if (today === currentDay) {
        return null;
    }
    return h(
        GoToTodayContainerStyled,
        {
            onClick,
        },
        `Today`,
    );
};
